import axios from 'axios'

export async function fetchFeatureToggles(token) {
  try {
    const url = process.env.VUE_APP_V3_FEATURE_TOGGLER
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  } catch (error) {
    console.error('Failed to fetch feature toggles', error)
    throw error
  }
}
